<template>
  <div class="rsu" style="position: relative; border: 1px solid #beccdb; border-radius: 8px">
    <v-layout row wrap class="mb-0">
      <v-flex
        xs12
        style="padding: 14px 20px 14px 14px; background: #beccdb; border-radius: 6px 6px 0px 0px"
      >
        <div style="display: flex; align-items: center">
          <Typography h3 bold color="color-mediumBlue" label="กระบวนการ" />
        </div>
      </v-flex>
      <v-flex xs12 class="rsu">
        <div
          v-for="(step, k) in value.steps.slice(0, value.steps.length - 1)"
          :key="step.id"
          class="mx-3 mt-3"
          style="border: 1px solid #beccdb; border-radius: 6px"
        >
          <div>
            <div v-if="k > 0" style="position: absolute; right: 20px">
              <v-btn @click="value.steps.splice(k, 1)" icon><v-icon>close</v-icon></v-btn>
            </div>
            <v-layout class="pa-3" style="width: 100%" column wrap>
              <label>
                <Typography h5 semiBold color="color-darkGrey" :label="`ขั้นตอนที่ ${k + 1}`"
              /></label>
              <div
                class="form-control"
                style="margin-bottom: 10px"
                :class="{ 'has-error': errors.has('ชื่อขั้นตอน' + dataindex + ' ' + k) }"
              >
                <input
                  :name="'ชื่อขั้นตอน' + dataindex + ' ' + k"
                  :data-vv-as="'ชื่อขั้นตอน'"
                  v-validate="'required'"
                  v-model="value.steps[k].name"
                  placeholder="ขั้นสมัคร"
                  class="depainput rsu mb-0"
                  style="padding-left: 14px !important"
                  type="search"
                  :disabled="k == 0 || k == value.steps.length - 1"
                />
                <span class="text-error" v-if="errors.has('ชื่อขั้นตอน' + dataindex + ' ' + k)">{{
                  errors.first('ชื่อขั้นตอน' + dataindex + ' ' + k)
                }}</span>
              </div>
              <label>
                <Typography h5 semiBold color="color-darkGrey" :label="`แบบฟอร์มโครงการ`"
              /></label>
              <div
                class="form-control"
                :class="{ 'has-error': errors.has('แบบฟอร์มโครงการ' + dataindex + ' ' + k) }"
              >
                <multiselect
                  :data-vv-as="'แบบฟอร์มโครงการ'"
                  :name="'แบบฟอร์มโครงการ' + dataindex + ' ' + k"
                  v-validate="'required'"
                  :searchable="true"
                  :options="optionsForm.map(val => val.id)"
                  v-model="value.steps[k].customform"
                  :custom-label="customLabel"
                  :max-height="190"
                >
                  <span slot="caret" slot-scope="{ toggle }" class="arrow">
                    <v-icon aria-hidden="false" size="24px">
                      mdi-chevron-down
                    </v-icon>
                  </span></multiselect
                >
                <span
                  class="text-error"
                  v-if="errors.has('แบบฟอร์มโครงการ' + dataindex + ' ' + k)"
                  >{{ errors.first('แบบฟอร์มโครงการ' + dataindex + ' ' + k) }}</span
                >
              </div>
            </v-layout>
          </div>
        </div>
      </v-flex>
      <v-flex xs12>
        <div class="text-xs-left">
          <v-btn
            @click="addStep"
            small
            depressed
            color="#BECCDB"
            round
            class="ml-3 mt-3 px-3"
            style="text-transform: capitalize; color: #0c2f53; height: 36px"
          >
            <i class="fas fa-plus mr-2"></i
            ><Typography h5 semiBold color="color-darkBlue" :label="`เพิ่มขั้นตอน`"
          /></v-btn>
        </div>
      </v-flex>
      <v-flex xs12 class="rsu">
        <div
          v-for="(step, k) in value.steps.slice(value.steps.length - 1)"
          :key="step.id"
          class="ma-3"
          style="border: 1px solid #beccdb; border-radius: 6px"
        >
          <div>
            <v-layout class="pa-3" style="width: 100%" column wrap>
              <label>
                <Typography
                  h5
                  semiBold
                  color="color-darkGrey"
                  :label="`ขั้นตอนที่ ${value.steps.length}`"
              /></label>
              <div
                class="form-control"
                style="margin-bottom: 10px"
                :class="{
                  'has-error': errors.has('ชื่อขั้นตอน' + dataindex + ' ' + k)
                }"
              >
                <input
                  :name="'ชื่อขั้นตอน' + dataindex + ' ' + k"
                  :data-vv-as="'ชื่อขั้นตอน'"
                  v-validate="'required'"
                  v-model="value.steps[value.steps.length - 1].name"
                  placeholder="ขั้นสมัคร"
                  class="depainput rsu mb-0"
                  style="padding-left: 14px !important"
                  type="search"
                  :disabled="k == 0"
                />
                <span class="text-error" v-if="errors.has('ชื่อขั้นตอน' + dataindex + ' ' + k)">{{
                  errors.first('ชื่อขั้นตอน' + dataindex + ' ' + k)
                }}</span>
              </div>
              <label>
                <Typography h5 semiBold color="color-darkGrey" :label="`แบบฟอร์มโครงการ`"
              /></label>
              <div
                class="form-control"
                :class="{
                  'has-error': errors.has('แบบฟอร์มโครงการ' + dataindex + ' ' + k)
                }"
              >
                <multiselect
                  :data-vv-as="'แบบฟอร์มโครงการ'"
                  :name="'แบบฟอร์มโครงการ' + dataindex + ' ' + k"
                  v-validate="'required'"
                  :searchable="true"
                  :options="optionsForm.map(val => val.id)"
                  v-model="value.steps[value.steps.length - 1].customform"
                  :custom-label="customLabel"
                  :max-height="200"
                >
                  <span slot="caret" slot-scope="{ toggle }" class="arrow">
                    <v-icon aria-hidden="false" size="24px">
                      mdi-chevron-down
                    </v-icon>
                  </span></multiselect
                >
                <span
                  class="text-error"
                  v-if="errors.has('แบบฟอร์มโครงการ' + dataindex + ' ' + k)"
                  >{{ errors.first('แบบฟอร์มโครงการ' + dataindex + ' ' + k) }}</span
                >
              </div>
            </v-layout>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import Multiselect from 'vue-multiselect'
import Typography from '@/components/elements/Typography.vue'
import uniqid from 'uniqid'

export default {
  props: {
    value: {
      default: null
    },
    dataindex: {
      default: null
    }
  },
  inject: ['$validator'],
  data() {
    return {
      uid: 0,
      tagOptions: [],
      update_tags: [],
      steps: [{ name: '', customform: { formname: '' }, id: uniqid() }]
    }
  },
  components: {
    DropdownMenu,
    Multiselect,
    Typography
  },
  mounted() {
    console.log(this.optionsForm)
    console.log(this.value)
  },
  computed: {
    optionsForm() {
      return this.$store.state.formdata
    }
  },
  methods: {
    addTag(newTag, k) {
      const tag = newTag
      this.tagOptions.push(tag)
      if (!this.value.steps[k].tags) {
        Object.assign(this.value.steps[k], {
          tags: []
        })
      }

      this.value.steps[k].tags.push(tag)
      this.update_tags.push(tag)
    },
    customLabel(opt) {
      var form = this.optionsForm.find(x => {
        return x.id == opt
      })
      if (form) {
        return form.formname
      } else {
        return ''
      }
    },
    update(key, value) {
      this.$emit('input', { ...this.value, [key]: value })
    },
    addStep() {
      this.value.steps.splice(this.value.steps.length - 1, 0, {
        name: '',
        customform: '',
        id: uniqid()
        // dpType: 'Non-DP',
        // tags: null,
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/projectMaster/ProjectTypeItem.vue